import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const registerUser = async (userData) => {
  const response = await axios.post(baseUrl + '/api/users', userData)
  
  // console.log(response)
  
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

const loginUser = async (userData) => {
  const response = await axios.post(baseUrl + '/api/users/login', userData)
  
  // console.log(response)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

const getUserObject = async (token) => {

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const response = await axios.get(baseUrl + '/api/users/getUserObject', config)
  
  // console.log(response)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

const logoutUser = () => {
  localStorage.removeItem('user')
}

const verifyEmail = async (verifyData) => {
  const response = await axios.post(baseUrl + '/api/users/verifyEmail', verifyData)

  return response.data
}

const requestPasswordResetEmail = async (formData) => {
  const response = await axios.post(baseUrl + '/api/users/requestPasswordResetEmail', formData)

  return response.data
}

const forgottenPasswordReset = async (formData) => {
  const response = await axios.post(baseUrl + '/api/users/forgottenPasswordReset', formData)

  return response.data
}

const updateUserPreferences = async (preferencesData, token) => {

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  }

  const { isOperatorEnabled, promotionalEmailsConsent, homeCountryCode, selectedBackground, enablePublicProfile } = preferencesData

  const requestData = {
      isOperatorEnabled: isOperatorEnabled,
      promotionalEmailsConsent: promotionalEmailsConsent,
      enablePublicProfile: enablePublicProfile,
      displayName: preferencesData.displayName,
      homeCountryCode: homeCountryCode,
      selectedBackground: selectedBackground,
  }

  const response = await axios.post(baseUrl + `/api/users/updateUserPreferences`, requestData, config)

  if (response.data) {
      localStorage.setItem('user', JSON.stringify(response.data))
  }

  // console.log(response)
  return response.data
}

const authService = {
  registerUser,
  loginUser,
  getUserObject,
  logoutUser,
  verifyEmail,
  requestPasswordResetEmail,
  forgottenPasswordReset,
  updateUserPreferences,
}

export default authService